module.exports = __webpack_public_path__ + "static/scale-model-of-glendale-california-2947d900cb273950a5a2c212c2bfb5ba.png";